import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  AssistanceModule,
  AssistanceResource,
  CreateAssistanceResourceDto,
  UpdateAssistanceResourceDto,
  UpsertAssistanceModuleDto,
} from '../interfaces/assistance-resource';
import {
  ApiCollectionResponse,
  ApiSingleResponse,
  ApiSimpleResponse,
} from '../interfaces/responses/api-response';

@Injectable({ providedIn: 'root' })
export class AdminAssistanceService {
  private readonly base = `${environment.BASE_URL}/admin/assistance`;

  constructor(private http: HttpClient) {}

  // ── Modules ───────────────────────────────────────────────

  /** Modules des trois publics, chacun avec sa série. */
  getModules(includeArchived = false): Observable<ApiCollectionResponse<AssistanceModule>> {
    let params = new HttpParams();
    if (includeArchived) params = params.set('includeArchived', true);
    return this.http.get<ApiCollectionResponse<AssistanceModule>>(`${this.base}/modules`, { params });
  }

  createModule(dto: UpsertAssistanceModuleDto): Observable<ApiSingleResponse<AssistanceModule>> {
    return this.http.post<ApiSingleResponse<AssistanceModule>>(`${this.base}/modules`, dto);
  }

  updateModule(id: number, dto: UpsertAssistanceModuleDto): Observable<ApiSingleResponse<AssistanceModule>> {
    return this.http.put<ApiSingleResponse<AssistanceModule>>(`${this.base}/modules/${id}`, dto);
  }

  /** Archive le module et toute sa série. */
  archiveModule(id: number): Observable<ApiSimpleResponse> {
    return this.http.delete<ApiSimpleResponse>(`${this.base}/modules/${id}`);
  }

  /** Ordre complet de la série, en un seul appel. */
  reorderModule(id: number, resourceIds: number[]): Observable<ApiSingleResponse<AssistanceModule>> {
    return this.http.put<ApiSingleResponse<AssistanceModule>>(`${this.base}/modules/${id}/order`, { resourceIds });
  }

  // ── Ressources ────────────────────────────────────────────

  getById(id: number): Observable<ApiSingleResponse<AssistanceResource>> {
    return this.http.get<ApiSingleResponse<AssistanceResource>>(`${this.base}/${id}`);
  }

  create(dto: CreateAssistanceResourceDto): Observable<ApiSingleResponse<AssistanceResource>> {
    return this.http.post<ApiSingleResponse<AssistanceResource>>(this.base, dto);
  }

  update(id: number, dto: UpdateAssistanceResourceDto): Observable<ApiSingleResponse<AssistanceResource>> {
    return this.http.put<ApiSingleResponse<AssistanceResource>>(`${this.base}/${id}`, dto);
  }

  archive(id: number): Observable<ApiSimpleResponse> {
    return this.http.delete<ApiSimpleResponse>(`${this.base}/${id}`);
  }

  download(id: number): Observable<HttpResponse<Blob>> {
    return this.http.get(`${this.base}/${id}/download`, {
      observe: 'response',
      responseType: 'blob',
    });
  }
}
